import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import {
  getTablesOverviewRequest,
  getDailyTurnOverRequest,
  getDailyTurnoverForPast8DaysByRestaurantsRequest,
} from "../../services/dashboardService";
import { getToken } from "../../utils/utility";
import { notification } from "antd";

export function* getTablesOverview() {
  try {
    const token = getToken().get("idToken");

    const response = yield call(getTablesOverviewRequest, token);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_TABLES_OVERVIEW_SUCCESS,
        tablesOverview: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* getDailyTurnOver({ startDate, endDate }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      getDailyTurnOverRequest,
      token,
      startDate,
      endDate
    );
    if (response[0] === 200) {
      yield put({
        type: actions.GET_DAILY_TURNOVER_SUCCESS,
        dailyTurnOver: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* getDailyTurnoverForPast8DaysByRestaurants() {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      getDailyTurnoverForPast8DaysByRestaurantsRequest,
      token
    );
    if (response[0] === 200) {
      // if (response[1].length === 0) {}
      yield put({
        type: actions.GET_DAILY_TURNOVER_FOR_PAST_8_DAYS_BY_RESTAURANT_SUCCESS,
        dailyTurnoverForPast8DaysByRestaurants: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_TABLES_OVERVIEW_REQUEST, getTablesOverview),
    yield takeEvery(actions.GET_DAILY_TURNOVER_REQUEST, getDailyTurnOver),

    yield takeEvery(
      actions.GET_DAILY_TURNOVER_FOR_PAST_8_DAYS_BY_RESTAURANT_REQUEST,
      getDailyTurnoverForPast8DaysByRestaurants
    ),
  ]);
}
